import type { CanAccessOrganizationParams } from '../types';

/**
 * Mirrors services/auth/principal canPrincipalAccessOrganization for the webapp hook.
 * Empty organization IDs never grant access.
 */
const canAccessOrganization = ({
    isAdmin,
    developerOrganizationIds,
    organizationId,
}: CanAccessOrganizationParams): boolean => {
    if (organizationId.length === 0) {
        return false;
    }
    if (isAdmin) {
        return true;
    }
    return developerOrganizationIds.includes(organizationId);
};

export default canAccessOrganization;
